import { Card } from '../../Card';

import type { CardHeaderProps } from '../../Card/Header';

export const Header = ({ children, ...props }: CardHeaderProps) => (
  <Card.Header titleColor="grey-light" {...props}>
    {children}
  </Card.Header>
);
